import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { joinWithPipe } from "@/utils/common"

function Seo({ description, lang, meta, keywords, title, storeTitle, canonicalUrl }: any) {
  const cleanStoreTitle = storeTitle?.trim() || '';
  title = joinWithPipe([(title ?? ''), storeTitle])

  // Filter out the noindex meta tag
  const filteredMeta = meta.filter((tag: any) => !((tag.name === 'robots' || tag.name === 'Googlebot') || tag.content === 'noindex'));
  const defaultMeta = [
    { name: "title", content: title },
    { name: `description`, content: description, },

    { property: `og:title`, content: title, },
    { property: `og:description`, content: description },

    { name: `twitter:title`, content: title, },
    { name: `twitter:description`, content: description, },

    { property: `og:type`, content: `website`, },
    { name: `twitter:card`, content: `summary` },
  ]

  if (keywords.length > 0) {
    defaultMeta.push({
      name: `keywords`,
      content: keywords,
    })
    defaultMeta.push({
      name: `og:keywords`,
      content: keywords,
    })
    defaultMeta.push({
      name: `twitter:keywords`,
      content: keywords,
    })
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[...defaultMeta, ...meta]}
    // titleTemplate={`%s | ${site.siteMetadata.title}`}
    >
      <meta
        httpEquiv="Content-Security-Policy"
        content="connect-src 'self' https://qmapi.qmint.com http://localhost:5266 https://qmintstoremedia.blob.core.windows.net https://cdn.jsdelivr.net https://www.google.com https://api.ipify.org https://analytics.google.com https://www.google-analytics.com/g/collect https://www.google-analytics.com https://www.googletagmanager.com https://www.googletagmanager.com/gtm.js https://www.gstatic.com https://maps.googleapis.com https://ingesteer.services-prod.nsvcs.net https://stats.g.doubleclick.net https://ipapi.co"

      />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {/* <meta name="robots" content="noindex,nofollow"></meta> */}
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css" integrity="sha512-DTOQO9RWCH3ppGqcWaEA1BIZOC6xxalwEsw9c2QQeAIftl+Vegovlnee1c9QX4TctnWMn13TZye+giMm8e2LwA==" crossOrigin="anonymous" referrerPolicy="no-referrer" />
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `en`,
  keywords: [],
  meta: [],
  isItShopPage: false
}

Seo.propTypes = {
  description: PropTypes.string,
  keywords: PropTypes.string, //PropTypes.arrayOf(PropTypes.string),
  lang: PropTypes.string,
  meta: PropTypes.array,
  title: PropTypes.string,
  canonicalUrl: PropTypes.string,
  storeTitle: PropTypes.string,
}

export default React.memo(Seo)
